var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { media } from '../..';
import { cleanWhite, jetBlack } from '../../colors';
import { LeftSide, RightSide, WidgetIcon, WidgetItem, ToggableWidgetWrapper, Wrapper, Link } from '../Header.styles';
import Hamburger from './hamburger';
import MobileMenu from './mobile-menu';
import SecondarySubmenu from '../secondary-submenu';
import LanguageSwitcher from '../language-switcher';
import DataPresenter from '../../data-presenter';
export var MobileWrapper = styled(Wrapper).withConfig({
  displayName: "header-mobile__MobileWrapper",
  componentId: "sc-19gap2b-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n  ", " {\n    display: flex;\n  }\n\n  transition: all 0.2s;\n  ", "\n"], ["\n  display: none;\n  ", " {\n    display: flex;\n  }\n\n  transition: all 0.2s;\n  ", "\n"])), media.max(768), function (pr) {
  return pr.isMenuOpen && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    position: absolute;\n    z-index: 15;\n  "], ["\n    background-color: ", ";\n    position: absolute;\n    z-index: 15;\n  "])), jetBlack());
});
var HamburgerWithMargin = styled(Hamburger).withConfig({
  displayName: "header-mobile__HamburgerWithMargin",
  componentId: "sc-19gap2b-1"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  margin-right: 2.6rem;\n"], ["\n  display: block;\n  margin-right: 2.6rem;\n"])));
export var MobileLogo = styled.div.withConfig({
  displayName: "header-mobile__MobileLogo",
  componentId: "sc-19gap2b-2"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 12.8rem;\n  height: 6.4rem;\n  background-color: ", ";\n  background-repeat: no-repeat;\n  mask: url('", "') no-repeat center;\n  mask-size: contain;\n"], ["\n  width: 12.8rem;\n  height: 6.4rem;\n  background-color: ", ";\n  background-repeat: no-repeat;\n  mask: url('", "') no-repeat center;\n  mask-size: contain;\n"])), function (pr) {
  return pr.isMenuOpen ? cleanWhite() : jetBlack();
}, function (pr) {
  return pr.url;
});
var TabletOnly = styled(RightSide).withConfig({
  displayName: "header-mobile__TabletOnly",
  componentId: "sc-19gap2b-3"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: block;\n  ", " {\n    display: none;\n  }\n"], ["\n  display: block;\n  ", " {\n    display: none;\n  }\n"])), media.sm);

var HeaderMobile = function HeaderMobile(_a) {
  var isLoading = _a.isLoading,
      content = _a.content,
      _b = _a.locale,
      locale = _b === void 0 ? 'en' : _b,
      _c = _a.linkComponent,
      linkComponent = _c === void 0 ? 'a' : _c,
      _d = _a.widgetActions,
      widgetActions = _d === void 0 ? {} : _d,
      _e = _a.translationLinks,
      translationLinks = _e === void 0 ? [] : _e,
      _f = _a.t,
      t = _f === void 0 ? function (key) {
    return key;
  } : _f,
      state = __rest(_a, ["isLoading", "content", "locale", "linkComponent", "widgetActions", "translationLinks", "t"]);

  var isMenuOpen = state.isMenuOpen;
  var currentSubmenuId = state.headerSubmenu;
  var secondaryRefs = useRef([]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileWrapper, {
    "data-test": 'header-mobile',
    isMenuOpen: isMenuOpen
  }, /*#__PURE__*/React.createElement(LeftSide, null, isLoading || !content ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: '2.6rem'
    }
  }, /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading || false,
    width: 3.2,
    height: 3
  })) : /*#__PURE__*/React.createElement(HamburgerWithMargin, {
    isMenuOpen: isMenuOpen,
    onClick: function onClick() {
      return !isLoading && state.setMenuOpen(!isMenuOpen);
    }
  }), isLoading || !content ? /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading || false,
    width: 6,
    height: 4
  }) : /*#__PURE__*/React.createElement(Link, {
    as: linkComponent,
    href: (content === null || content === void 0 ? void 0 : content.homeUrl) || '/',
    onClick: function onClick() {
      return !isLoading && state.setMenuOpen(false);
    }
  }, /*#__PURE__*/React.createElement(MobileLogo, {
    url: content.logo.url,
    isMenuOpen: isMenuOpen,
    role: 'img',
    "aria-label": content.logo.alternativeText || '',
    "data-gtm": 'header-logo-mobile'
  }))), /*#__PURE__*/React.createElement(RightSide, null, isLoading || !content ? [1, 2].map(function (i) {
    return /*#__PURE__*/React.createElement(ToggableWidgetWrapper, {
      key: i,
      isVisible: true
    }, /*#__PURE__*/React.createElement(DataPresenter, {
      nodata: true,
      loading: isLoading || false,
      width: 8,
      height: 2
    }));
  }) : content.secondaryNavigationLinks.map(function (secLink, i) {
    var _a;

    return /*#__PURE__*/React.createElement(ToggableWidgetWrapper, {
      key: secLink.id,
      isVisible: !isMenuOpen
    }, ((_a = secLink === null || secLink === void 0 ? void 0 : secLink.submenuItems) === null || _a === void 0 ? void 0 : _a.length) ? /*#__PURE__*/React.createElement(WidgetItem, {
      "data-test": 'header-mobile-sec-submenu-toggler',
      ref: function ref(el) {
        if (secondaryRefs === null || secondaryRefs === void 0 ? void 0 : secondaryRefs.current) {
          secondaryRefs.current[i] = {
            current: el
          };
        }
      },
      onClick: function onClick() {
        /* Close popup since it won't close for this element */
        if (currentSubmenuId === "mob-sec-" + secLink.id) {
          state.setHeaderSubmenu(null);
          return;
        }

        state.setHeaderSubmenu("mob-sec-" + secLink.id);
      }
    }, /*#__PURE__*/React.createElement(WidgetIcon, {
      src: secLink.icon.url,
      alt: secLink.icon.alternativeText || '',
      loading: 'lazy'
    }), /*#__PURE__*/React.createElement(TabletOnly, null, secLink.label)) : /*#__PURE__*/React.createElement(WidgetItem, {
      onClick: function onClick() {
        if (!widgetActions[secLink.handlerId]) {
          throw new Error("Navigation link handler id\n                    doesnt match any action creator");
        }

        widgetActions[secLink.handlerId](locale);
      }
    }, /*#__PURE__*/React.createElement(WidgetIcon, {
      src: secLink.icon.url,
      alt: secLink.icon.alternativeText || '',
      loading: 'lazy'
    }), /*#__PURE__*/React.createElement(TabletOnly, null, secLink.label)), secLink.submenuItems && secLink.submenuItems.length > 0 && /*#__PURE__*/React.createElement(SecondarySubmenu, __assign({
      linkRefs: secondaryRefs,
      link: secLink,
      linkId: "mob-sec-" + secLink.id,
      isMobile: true,
      linkComponent: linkComponent
    }, state
    /* eslint-disable-line react/jsx-props-no-spreading, max-len */
    )));
  }), isMenuOpen ? /*#__PURE__*/React.createElement(LanguageSwitcher, {
    linkComponent: linkComponent,
    isIconShown: false,
    isTextLight: true,
    isFullText: true,
    translationLinks: translationLinks,
    t: t,
    locale: locale
  }) : /*#__PURE__*/React.createElement(TabletOnly, null, /*#__PURE__*/React.createElement(LanguageSwitcher, {
    linkComponent: linkComponent,
    translationLinks: translationLinks,
    t: t,
    locale: locale
  })))), isLoading || !content ? null : /*#__PURE__*/React.createElement(MobileMenu, __assign({
    navigationLinks: content.navigationLinks,
    secondaryNavLinks: content.secondaryNavigationLinks,
    widgetActions: widgetActions,
    linkComponent: linkComponent
  }, state
  /* eslint-disable-line react/jsx-props-no-spreading, max-len */
  )));
};

export default HeaderMobile;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;